module.exports = __webpack_public_path__ + "img/excel.23bac5d1.png";